import GcpSlice from './gcp.slice';

export const { actions: gcp_actions } = GcpSlice;

export default GcpSlice.reducer;
